export default __webpack_public_path__ + "static/media/main.0c9930c7.jpg";